import { keyframes } from '@emotion/react';
import { Portal } from '@mui/base/Portal';
import { cssTransition, ToastContainer } from 'react-toastify';

const slideIn = keyframes({
	'0%': {
		transform: 'translateY(-150%)',
		visibility: 'visible',
	},
	'100%': {
		transform: 'translateY(0)',
	},
});

const slideOut = keyframes({
	'0%': {
		transform: 'translateY(0)',
	},
	'100%': {
		transform: 'translateY(-150%)',
		visibility: 'hidden',
	},
});

const toastEnterClass = 'toast-enter';
const toastExitClass = 'toast-exit';

export function HubToastContainer() {
	return (
		<Portal>
			<ToastContainer
				closeOnClick
				css={[
					{ width: 'auto', maxWidth: '42rem' },
					{
						[`.${toastEnterClass}`]: {
							animationName: slideIn,
							animationFillMode: 'forwards',
							animationDuration: '0.5s',
						},
						[`.${toastExitClass}`]: {
							animationName: slideOut,
							animationFillMode: 'forwards',
							animationDuration: '0.5s',
						},
					},
				]}
			/>
		</Portal>
	);
}

export const hubToastTransition = cssTransition({
	enter: toastEnterClass,
	exit: toastExitClass,
});
